import React, { Component } from 'react';

export default class AfterVideo extends Component {
  render() {
    return (
      <iframe className='about-video' src='https://www.youtube.com/embed/ECUy0JbMgtk'/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing/blocks/AfterVideo.js